import script from "./ShowVistorias.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowVistorias.vue?vue&type=script&setup=true&lang=js"

import "./ShowVistorias.vue?vue&type=style&index=0&id=28f16175&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28f16175"]])

export default __exports__